export type AnnouncementsTranslation = {
  button: {
    label: string;
  };
  coachmark: {
    button: {
      close: string;
      next: string;
      skip: string;
    };
    progress: string;
  };
  items: {
    calendarStatusLegend: Feature;
    contactsMenuItemInactiveConflictFix: Feature;
    customersIndividualDistinguishingLabel: Feature;
    dashboardProcesses: Feature;
    dashboardQuickActions: Feature;
    dashboardTasks: Feature;
    emailAttachOffer: Feature;
    emailsCopyRecipients: Feature;
    emailsProcessMatch: Feature;
    multiOfferBrowsePanel: Feature;
    offerCopyAsVersion: Feature;
    offerEmailsSection: Feature;
    offerExtraElements: Feature;
    offerGroupsStructure: Feature;
    offerPdfPreviewFab: Feature;
    offersAddPredefined: Feature;
    offersCalendarTab: Feature;
    offersListTab: Feature;
    offersOwnerPagesTab: Feature;
    offersTemplatesTab: Feature;
    predefinedOfferRecurrence: Feature;
    processMultiOffersTab: Feature;
    tasksFullTextSearch: Feature;
    tasksMenuItemWatchersAccess: Feature;
    topBarAnnouncements: Feature;
    topBarFeedback: Feature;
  };
  panel: {
    close: string;
    empty: string;
    preview: string;
    subtitle: string;
    title: string;
    unavailable: string;
  };
  status: {
    new: string;
    seen: string;
  };
};

type Feature = { description: string; title: string };

export const announcementsTranslation: AnnouncementsTranslation = {
  button: {
    label: 'Nowości',
  },
  coachmark: {
    button: {
      close: 'Rozumiem',
      next: 'Dalej',
      skip: 'Pomiń',
    },
    progress: '{{current}} z {{total}}',
  },
  items: {
    calendarStatusLegend: {
      description:
        'Każde wydarzenie w kalendarzu jest pokolorowane zgodnie ze statusem oferty (np. szkic, sprzedana, zaakceptowana). Kliknij wybrany kolor w legendzie, żeby przefiltrować widok i zostawić tylko oferty o danym statusie — licznik obok pokaże, ile wydarzeń wpadło w filtr. Legenda pokazuje tylko te statusy, które widzisz w kalendarzu: anulowane oferty nie trafiają na niego nigdy, a szkice i ofertowanie wyłącznie w Twoich procesach.',
      title: 'Statusy w kalendarzu',
    },
    contactsMenuItemInactiveConflictFix: {
      description:
        'Naprawiliśmy konflikt przy dodawaniu danych kontaktowych do nowego kontaktu, gdy ta sama dana jest już użyta w innym, nieaktywnym wpisie. Nadal nie można użyć tej samej danej kontaktowej w dwóch aktywnych kontaktach.',
      title: 'Poprawka dodawania danych kontaktowych',
    },
    customersIndividualDistinguishingLabel: {
      description:
        'Dodaliśmy pole „Wyróżnik”, które pomaga rozróżnić klientów indywidualnych o tej samej nazwie. Wyświetlane jest w nawiasie, obok nazwy klienta. Wyróżnik można dodać i zmienić przy edycji klienta',
      title: 'Nowe pole: Wyróżnik',
    },
    dashboardProcesses: {
      description:
        'Kafelek pokazuje teraz, dlaczego proces czeka: termin najpilniejszego zadania (po terminie na czerwono — po najechaniu widać, ile dni minęło), ile zadań wisi i jakiego są rodzaju — ikona maila, przypomnienia albo zadania własnego. Chipy nad tabelką filtrują po zaległościach, dzisiejszych i nadchodzących terminach, a każdą kolumnę można kliknąć, żeby zmienić sortowanie. Domyślnie na górze jest najstarszy nieobsłużony termin.',
      title: 'Procesy wymagające uwagi',
    },
    dashboardQuickActions: {
      description:
        'Na górze dashboardu zebraliśmy skróty do najczęstszych akcji, żebyś mógł szybciej rozpocząć pracę.',
      title: 'Szybkie akcje na start',
    },
    dashboardTasks: {
      description:
        'Ten blok pokazuje bieżące zadania przypisane do Ciebie i zespołu bez przechodzenia do osobnego widoku.',
      title: 'Zadania pod ręką',
    },
    emailAttachOffer: {
      description:
        'Pisząc maila powiązanego z procesem, możesz jednym kliknięciem dołączyć PDF wybranej oferty z tego procesu. Otworzy się lista grup ofert — wybierasz wariant „oferta" albo „oferta realizacyjna" i plik trafia do załączników bez ręcznego generowania. Przycisk pojawia się tylko, gdy mail jest spięty z procesem.',
      title: 'Dołącz ofertę do maila',
    },
    emailsCopyRecipients: {
      description:
        'Adresy z listy odbiorców oraz kopii CC możesz teraz łatwo skopiować, kliknięciem ikony obok wybranego adresu.',
      title: 'Szybsze kopiowanie adresów email',
    },
    emailsProcessMatch: {
      description:
        'Przy tworzeniu procesu z wątku email system automatycznie wyszukuje dopasowania klientów, kontaktów i opiekunów. Wyniki wyświetlają się jako karty do wyboru — wystarczy kliknąć odpowiednią, aby uzupełnić dane procesu.',
      title: 'Dopasowania przy tworzeniu procesu',
    },
    multiOfferBrowsePanel: {
      description:
        'Z poziomu grupy ofert możesz przejrzeć wszystkie wcześniej tworzone oferty — zarówno procesowe, jak i predefiniowane. Otwórz panel, podejrzyj zawartość oferty i jednym kliknięciem skopiuj ją do bieżącej grupy. To wygodny sposób, żeby uniknąć budowania oferty od zera.',
      title: 'Przeglądanie ofert i kopiowanie',
    },
    offerCopyAsVersion: {
      description:
        'Jeśli musisz pokazać klientowi alternatywny wariant oferty, użyj przycisku „kopiuj jako wersję”. Tworzy on nową ofertę w tej samej grupie, zachowując poprzednią — masz pełną historię wersji i możesz wysłać klientowi kolejny wariant bez utraty oryginału.',
      title: 'Nowa wersja oferty',
    },
    offerEmailsSection: {
      description:
        'W tej sekcji znajdziesz całą korespondencję z klientem dotyczącą tej oferty. Maile są tu spięte automatycznie, żebyś nie musiał szukać ich w skrzynce — szybko zweryfikujesz, co i kiedy zostało wysłane oraz jaka była reakcja klienta.',
      title: 'Maile powiązane z ofertą',
    },
    offerExtraElements: {
      description:
        'Poza pozycjami menu możesz dopiąć do oferty dodatkowe elementy: zestawy, zestawy napojów, pakiety, transport, dekoracje i inne. Każdy rodzaj ma osobną sekcję, a koszty wliczają się do ceny całej oferty.',
      title: 'Dodatkowe elementy oferty',
    },
    offerGroupsStructure: {
      description:
        'Treść oferty porządkujemy w grupach i podgrupach, np. grupa „Kolacja” z podgrupą „Bufet zimny”, w której są konkretne dania. Struktura przekłada się 1:1 na układ PDF, więc klient od razu widzi przejrzysty układ menu.',
      title: 'Grupy i podgrupy w ofercie',
    },
    offerPdfPreviewFab: {
      description:
        'Okrągła ikona w prawym dolnym rogu otwiera podgląd PDF aktualnej oferty bez konieczności jej pobierania. Możesz w każdej chwili sprawdzić, jak oferta wygląda dla klienta — to ten sam plik, który ostatecznie zostanie wysłany.',
      title: 'Podgląd PDF oferty',
    },
    offersAddPredefined: {
      description:
        'Oferta predefiniowana to gotowy szablon, np. „Lunch dla 20 osób” albo „Standardowa kolacja firmowa”, który można wpiąć w dowolny proces bez budowania oferty od nowa. Stworzysz ją tym przyciskiem — pojawi się na liście i w kalendarzu ofert predefiniowanych.',
      title: 'Oferty predefiniowane',
    },
    offersCalendarTab: {
      description:
        'Zakładka „Kalendarz” pokazuje oferty predefiniowane w widoku miesięcznym lub tygodniowym. Od razu widać, na jakie dni dana oferta (np. lunch albo kolacja) jest dostępna. Klikając w pasek na liście dni otworzysz podgląd oferty, a ikoną PDF — podgląd dokumentu.',
      title: 'Kalendarz ofert predefiniowanych',
    },
    offersListTab: {
      description:
        'Centrum ofert spina wszystkie oferty wystawione w procesach. Filtrujesz po kliencie, dacie wydarzenia, statusie i wskakujesz wprost do oferty z poziomu wiersza — nie musisz wchodzić w proces, żeby je przejrzeć.',
      title: 'Lista ofert',
    },
    offersOwnerPagesTab: {
      description:
        'Strony osobiste to dodatkowy element PDF z danymi opiekuna oferty (np. wizytówka handlowca). Każdy użytkownik może mieć własną stronę — przy generowaniu oferty zostanie ona dołączona automatycznie do dokumentu.',
      title: 'Strony osobiste',
    },
    offersTemplatesTab: {
      description:
        'Szablony ofert określają, jak oferta będzie się prezentowała w PDF: układ stron, sekcje, kolejność, branding. Dodajesz tu nowy szablon i wskazujesz go potem na ofercie albo grupie ofert.',
      title: 'Szablony ofert',
    },
    predefinedOfferRecurrence: {
      description:
        'Dla oferty predefiniowanej możesz ustawić reguły dostępności — konkretne daty albo cykl (codzienny, tygodniowy, miesięczny, roczny, w wybrane dni tygodnia). Te reguły zasilają kalendarz ofert predefiniowanych, więc od razu widać, na kiedy oferta jest aktualna.',
      title: 'Cykliczność i kalendarz oferty predefiniowanej',
    },
    processMultiOffersTab: {
      description:
        'Grupa ofert spina kilka ofert wystawianych w ramach jednego procesu — np. dla wydarzenia trwającego kilka dni, gdzie każdy dzień ma osobną ofertę. Najprostsza grupa zawiera tylko jedną ofertę. Każda grupa ma swój szablon PDF i status.',
      title: 'Grupy ofert na procesie',
    },
    tasksFullTextSearch: {
      description: 'Zadania można wyszukiwać po tytule i treści opisu',
      title: 'Usprawnienie wyszukiwania',
    },
    tasksMenuItemWatchersAccess: {
      description:
        'Zaktualizowaliśmy dostęp do zadań prywatnych. Od teraz osoby ustawione jako obserwatorzy mogą wyszukiwać i przeglądać takie zadania.',
      title: 'Dostęp do zadań dla obserwatorów',
    },
    topBarAnnouncements: {
      description:
        'W tym miejscu otworzysz listę najnowszych zmian i wrócisz do opisów funkcji, kiedy będziesz ich potrzebować.',
      title: 'Centrum nowości',
    },
    topBarFeedback: {
      description:
        'Przycisk zgłoszenia błędu jest teraz stale dostępny w top barze, więc możesz szybko przekazać problem lub sugestię.',
      title: 'Szybkie zgłaszanie uwag',
    },
  },
  panel: {
    close: 'Zamknij',
    empty: 'Na tym ekranie nie ma teraz aktywnych opisów.',
    preview: 'Pokaż opis',
    subtitle: 'Krótki przegląd zmian i najważniejszych elementów bieżącego widoku.',
    title: 'Nowości w aplikacji',
    unavailable: 'Niedostępne na tym ekranie',
  },
  status: {
    new: 'Nowe',
    seen: 'Widziane',
  },
};
